import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import { MerchProduct } from '@services/merch/types/api/merch-product';

interface OwnerDesktopMerchRowProps {
  item: MerchProduct;
}

const OwnerDesktopMerchRow: FunctionComponent<OwnerDesktopMerchRowProps> = ({
  item,
}) => {
  return (
    <Wrapper>
      <Flex
        className="quantity"
        justifyContent="space-between"
        alignItems="center"
        gap={10}
      >
        {/* TODO: DEVTEAM-603 - This is for demo only. We need to show the correct amount of merch. item.qty shouldn't be optional */}
        {/* <Typography type="small">{item.qty ? item.qty : '0'}</Typography> */}
        <Typography type="small">{item.qty ? item.qty : '10'}</Typography>
      </Flex>

      <div className="third-column">
        {/* TODO: DEVTEAM-603 - This needs to be integrated, currently we don't have ownership on each product */}
        {/* <Typography type="small">{item.ownership}</Typography> */}
        <Typography type="small">100%</Typography>
      </div>
      <div className="fourth-column">
        {/* TODO: DEVTEAM-603 - This needs to be integrated, currently we don't have stakeholders on each product */}
        {/* <Typography type="small">{item.stakeholders}</Typography> */}
        <Typography type="small">1</Typography>
      </div>
    </Wrapper>
  );
};

export default OwnerDesktopMerchRow;

const Wrapper = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(18, minmax(0, 1fr));

  .avatar {
    grid-column: 1 / 2;
  }

  .quantity {
    grid-column: 2 / 8;
  }

  .third-column {
    grid-column: 8 / 11;
  }

  .fourth-column {
    grid-column: 11 / 15;
  }
`;

export const SongNumber = styled(Flex)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};

  .number {
    color: ${({ theme }) => theme.colors.differentBackground};
  }

  &.nft {
    background-color: ${({ theme }) => theme.colors.secondary};

    .number {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;
